/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Source creation request
 * @export
 * @interface CreateCaseSourceRequest
 */
export interface CreateCaseSourceRequest {
    /**
     * External source ID from the originating system
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceId: string;
    /**
     * Type of the source system
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceType?: string;
    /**
     * Name of the source system
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceName?: string;
    /**
     * Source technology code for case resolution (any string; required for custom integrations). When omitted, sourceTechnology is used as the code.
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceTechnologyCode?: string;
    /**
     * Technology used by the source system (enum name or custom code)
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceTechnology: string;
    /**
     * URL to the source system or alert
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceUrl?: string;
    /**
     * Description of the source
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    sourceDescription?: string;
    /**
     * Correlation group for linking related sources
     * @type {string}
     * @memberof CreateCaseSourceRequest
     */
    correlationGroup?: string;
    /**
     * Additional metadata from the source system
     * @type {{ [key: string]: any; }}
     * @memberof CreateCaseSourceRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * Whether this is the primary source for the case
     * @type {boolean}
     * @memberof CreateCaseSourceRequest
     */
    isPrimarySource?: boolean;
    /**
     * Last synchronization time with the source system
     * @type {Date}
     * @memberof CreateCaseSourceRequest
     */
    lastSyncTime?: Date;
}

/**
 * Check if a given object implements the CreateCaseSourceRequest interface.
 */
export function instanceOfCreateCaseSourceRequest(value: object): value is CreateCaseSourceRequest {
    if (!('sourceId' in value) || value['sourceId'] === undefined) return false;
    if (!('sourceTechnology' in value) || value['sourceTechnology'] === undefined) return false;
    return true;
}

export function CreateCaseSourceRequestFromJSON(json: any): CreateCaseSourceRequest {
    return CreateCaseSourceRequestFromJSONTyped(json, false);
}

export function CreateCaseSourceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseSourceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceId': json['sourceId'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'sourceTechnologyCode': json['sourceTechnologyCode'] == null ? undefined : json['sourceTechnologyCode'],
        'sourceTechnology': json['sourceTechnology'],
        'sourceUrl': json['sourceUrl'] == null ? undefined : json['sourceUrl'],
        'sourceDescription': json['sourceDescription'] == null ? undefined : json['sourceDescription'],
        'correlationGroup': json['correlationGroup'] == null ? undefined : json['correlationGroup'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'isPrimarySource': json['isPrimarySource'] == null ? undefined : json['isPrimarySource'],
        'lastSyncTime': json['lastSyncTime'] == null ? undefined : (new Date(json['lastSyncTime'])),
    };
}

export function CreateCaseSourceRequestToJSON(json: any): CreateCaseSourceRequest {
    return CreateCaseSourceRequestToJSONTyped(json, false);
}

export function CreateCaseSourceRequestToJSONTyped(value?: CreateCaseSourceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceId': value['sourceId'],
        'sourceType': value['sourceType'],
        'sourceName': value['sourceName'],
        'sourceTechnologyCode': value['sourceTechnologyCode'],
        'sourceTechnology': value['sourceTechnology'],
        'sourceUrl': value['sourceUrl'],
        'sourceDescription': value['sourceDescription'],
        'correlationGroup': value['correlationGroup'],
        'metadata': value['metadata'],
        'isPrimarySource': value['isPrimarySource'],
        'lastSyncTime': value['lastSyncTime'] == null ? undefined : ((value['lastSyncTime']).toISOString()),
    };
}

